export const selectVehicles = (state) => state.vehicles;

export const selectVehicleList = (state) => state.vehicles.list;
export const selectVehicleListLoading = (state) => state.vehicles.loading;
export const selectVehicleListLoadingCount = (state) => state.vehicles.loadingCount;
export const selectVehicleListError = (state) => state.vehicles.error;
export const selectVehicleFilters = (state) => state.vehicles.filters;